import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, debounce, Footer, Image } from '@outdoor-voices/ui';
import { createPortal } from 'react-dom';
import { gsap } from 'gsap/dist/gsap';
import { isMobile, isTabletSmall } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { RESIZE } from '@outdoor-voices/ui/dist/config/constants';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useInView } from 'react-intersection-observer';
import cc from 'classcat';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { CDN, CDN_ROOT, DRESSES, FLATS, SELECTOR, TRIGGER_ID, VIDEO_PROPS, VIDEO_TRACK } from './constants';
import css from './index.module.scss';
import Dress1 from './Dress1';
import Dress2 from './Dress2';
import Dress3 from './Dress3';
import Nav from './Nav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
gsap.registerPlugin(ScrollTrigger);
var COMPONENTS = {
  Dress1: Dress1,
  Dress2: Dress2,
  Dress3: Dress3
};

var DressesCampaign = function DressesCampaign() {
  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(isMobile()),
      _useState4 = _slicedToArray(_useState3, 2),
      mobile = _useState4[0],
      setMobile = _useState4[1];

  var _useInView = useInView(),
      _useInView2 = _slicedToArray(_useInView, 2),
      inViewRef = _useInView2[0],
      inView = _useInView2[1];

  var videoRef = useRef(null);
  var dressesRef = useRef(null);
  var ycdaiadRef = useRef(null);

  var _onUpdate = useRef(function () {});

  var isDesktop = !isTabletSmall() && !mobile;
  var isTablet = isTabletSmall() && !mobile;
  useEffect(function () {
    if (mobile) {
      return;
    }

    var current = dressesRef.current;
    var pin = current.firstChild;
    var animator = pin.firstChild;

    var getToValue = function getToValue() {
      return -(animator.scrollWidth - window.innerWidth);
    };

    gsap.fromTo(animator, {
      x: 0
    }, {
      x: getToValue(),
      ease: 'none',
      scrollTrigger: {
        // anticipatePin: 1,
        end: function end() {
          return '+=' + (animator.scrollWidth - window.innerWidth);
        },
        id: TRIGGER_ID,
        // markers: true,
        onUpdate: function onUpdate(self) {
          _onUpdate.current(self);
        },
        pin: pin,
        scrub: 0.2,
        start: 'top 72px',
        trigger: current
      }
    });
    return function () {
      ScrollTrigger.refresh();
    };
  }, [mobile]);
  useEffect(function () {
    var trigger = ScrollTrigger.getById(TRIGGER_ID);

    if (!trigger) {
      return;
    }

    var current = dressesRef.current;
    var firstDress = current.querySelector(SELECTOR);

    _onUpdate.current = function (self) {
      var start = self.start + window.innerWidth;
      var newIndex = Math.floor((self.scroller.scrollY - start) / Math.ceil(firstDress.offsetWidth - 100));

      if (newIndex !== index) {
        setIndex(newIndex);
      }
    };
  }, [index]);

  var onClick = function onClick(newIndex) {
    var current = dressesRef.current;
    var target = window.innerWidth;

    _toConsumableArray(current.querySelectorAll(SELECTOR)).slice(0, newIndex).forEach(function (child) {
      target += child.offsetWidth;
    });

    var scroller = ScrollTrigger.getById(TRIGGER_ID);

    if (scroller) {
      scroller.scroll(scroller.start + target);
    }
  };

  useEffect(function () {
    var onResize = function onResize() {
      var newIsMobile = isMobile(); // Abort on no change

      if (mobile === newIsMobile) {
        return;
      }

      if (newIsMobile) {
        // Disable all scroll triggers if we're mobile
        ScrollTrigger.getAll().forEach(function (scroller) {
          scroller.disable();
        });
      } else {
        ScrollTrigger.refresh();
      }

      setMobile(newIsMobile);
    };

    var debouncedResize = debounce(onResize, 200);
    window.addEventListener(RESIZE, debouncedResize);
    return function () {
      window.removeEventListener(RESIZE, debouncedResize);
    };
  }, [mobile]);
  useEffect(function () {
    var current = videoRef.current;

    if (inView) {
      try {
        current.play();
      } catch (exc) {
        console.info('play error', exc);
      }
    } else {
      try {
        current.pause();
      } catch (exc) {
        console.info('pause error', exc);
      }
    }
  }, [inView]);
  var style = ".ov-nav-wrap { position: fixed; }";

  var track = /*#__PURE__*/_jsx("track", {
    kind: "subtitles",
    label: "english_subtitles",
    src: VIDEO_TRACK,
    srcLang: "en"
  });

  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      dangerouslySetInnerHTML: {
        __html: style
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: css.hero,
      ref: inViewRef,
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.heroText,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.heroCopy,
          children: "Introducing "
        }), /*#__PURE__*/_jsx("h1", {
          className: css.heroTitle,
          children: "OV Exercise Dresses"
        })]
      }), isDesktop && /*#__PURE__*/_jsxs("video", _objectSpread(_objectSpread({}, VIDEO_PROPS), {}, {
        poster: "".concat(CDN_ROOT, "HP_-_Dresses_-_Desktop.jpg"),
        ref: videoRef,
        children: [/*#__PURE__*/_jsx("source", {
          src: "".concat(CDN, "HeroDesktop3.mp4"),
          type: "video/mp4"
        }), track]
      })), isTablet && /*#__PURE__*/_jsxs("video", _objectSpread(_objectSpread({}, VIDEO_PROPS), {}, {
        poster: "".concat(CDN_ROOT, "HP_-_Dresses_-_Tablet.jpg"),
        ref: videoRef,
        children: [/*#__PURE__*/_jsx("source", {
          src: "".concat(CDN, "HeroTablet3.mp4"),
          type: "video/mp4"
        }), track]
      })), mobile && /*#__PURE__*/_jsxs("video", _objectSpread(_objectSpread({}, VIDEO_PROPS), {}, {
        poster: "".concat(CDN_ROOT, "HP_-_Dresses_-_Mobile.jpg"),
        ref: videoRef,
        children: [/*#__PURE__*/_jsx("source", {
          src: "".concat(CDN, "HeroMobile3.mp4"),
          type: "video/mp4"
        }), track]
      }))]
    }), /*#__PURE__*/_jsxs("div", {
      className: cc([css.intro, _defineProperty({}, css.off, index > 0)]),
      children: [/*#__PURE__*/_jsxs("h2", {
        className: css.introTitle,
        children: ["First, we made ", /*#__PURE__*/_jsx("em", {
          children: "The Exercise Dress"
        }), "."]
      }), /*#__PURE__*/_jsxs("p", {
        className: css.introText,
        children: ["The Exercise Dress reimagined the way we move and what we allow ourselves to move in. Hundreds of thousands of TEDs later (and counting), we\u2019ve only just begun proving \u2014 once and for all \u2014 that you can do anything in a dress.", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), "Now, meet a whole new lineup of Exercise Dresses. That\u2019s right, plural. Brand new ways to dress, for every way you move. Designed in the name of Recreation."]
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: css.scroller,
      ref: dressesRef,
      children: /*#__PURE__*/_jsxs("div", {
        className: css.pin,
        children: [/*#__PURE__*/_jsxs("div", {
          className: css.animation,
          children: [/*#__PURE__*/_jsx("div", {
            "aria-hidden": "true",
            className: css.ghost,
            role: "presentation",
            children: "\xA0"
          }), DRESSES.map(function (dress) {
            var Component = COMPONENTS[dress.component];
            return /*#__PURE__*/_jsx(Fragment, {
              children: /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, dress), {}, {
                isMobile: mobile
              }))
            }, dress.name);
          }), /*#__PURE__*/_jsx("div", {
            className: css.ycdaiad,
            ref: ycdaiadRef,
            children: /*#__PURE__*/_jsx("div", {
              children: "You can do anything in a dress."
            })
          })]
        }), /*#__PURE__*/_jsx(Nav, {
          dresses: DRESSES,
          index: index,
          onClick: onClick
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.dresses,
      children: [FLATS.map(function (flat, idx) {
        return /*#__PURE__*/_jsxs("a", {
          className: css.dressesItem,
          href: flat.url,
          children: [/*#__PURE__*/_jsx(Image, {
            alt: "Outdoor Voices Dress - ".concat(flat.name),
            height: 1200,
            src: "".concat(CDN_ROOT).concat(flat.src),
            sizes: [160, 400, 600, 900, 1200],
            width: 900
          }), /*#__PURE__*/_jsx("div", {
            className: css.dressesItemTitle,
            children: flat.name
          }), /*#__PURE__*/_jsx("div", {
            "aria-hidden": "true",
            className: css.dressesItemBg,
            role: "presentation"
          })]
        }, "dresses-".concat(idx));
      }), /*#__PURE__*/_jsx("div", {
        className: css.shop,
        children: /*#__PURE__*/_jsx(Button, {
          ariaLabel: "Click to shop dresses",
          big: true,
          href: "/collections/dresses",
          children: "Shop \u2014 Dresses"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: css.footer,
        children: /*#__PURE__*/_jsx(Footer, {})
      })]
    })]
  }), document.body);
};

export default DressesCampaign;